import React, { useState, useEffect } from "react";
import "./SubscriptionPopup.scss";
import ApiService from "./../../services/api-service";
import { getErrorString, getUserId, getUserDetail } from "./../../constants/function";
import notifier from "./../../components/Notifier";
import Loader from "./../../components/Loader";
import { useDispatch } from "react-redux";
import { getBalance } from "../../asyncAction/asyncBalance";

const SubscriptionPopup = ({ isOpen, onClose }) => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userId = getUserId();

  // Check subscription status when the popup opens
  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      if (isOpen && userId) {
        // First check cached user data
        const cachedUserData = getUserDetail();
        if (cachedUserData && cachedUserData.hasPremium !== undefined) {
          setIsSubscribed(cachedUserData.hasPremium);
          console.log("Using cached premium status:", cachedUserData.hasPremium);
        }
        
        // Then fetch fresh data from API
        setLoading(true);
        try {
          // Get user profile to check premium status
          const response = await ApiService.USER_PROFILE();
          console.log("USER_PROFILE response:", response);

          // Check hasPremium field for premium membership status
          if (response.result && response.result.hasPremium) {
            setIsSubscribed(true);
          } else {
            setIsSubscribed(false);
          }
          
          // Update cached data
          if (response.result) {
            localStorage.setItem("userData", JSON.stringify({ userData: response.result }));
          }
        } catch (error) {
          notifier.error(getErrorString(error));
        } finally {
          setLoading(false);
        }
      }
    };
    checkSubscriptionStatus();
  }, [isOpen, userId]);

  // Handle subscription when the user clicks the "Subscribe" button
  const handleSubscribe = async () => {
    try {
      setLoading(true);
      const response = await ApiService.CREATE_SUBSCRIPTIONS({ deviceType: 1 });
      console.log("Subscription creation response:", response);

      // Check if user already has subscription
      if (response.result?.alreadySubscribed || response.messageKey === "USER_ALREADY_HAS_PREMIUM") {
        setIsSubscribed(true);
        notifier.info("You already have an active Premium subscription!");
        if (response.result?.subscription?.endDate) {
          notifier.info(`Your subscription is active until ${new Date(response.result.subscription.endDate).toLocaleDateString()}`);
        }
      } else if (response.data?.status === "success" || response.result?.success || response.status === "success") {
        setIsSubscribed(true);
        dispatch(getBalance());
        notifier.success("Subscription successful! Welcome to Premium!");
        
        // Update local user data to reflect premium status
        const userData = getUserDetail();
        if (userData) {
          userData.hasPremium = true;
          localStorage.setItem("userData", JSON.stringify({ userData }));
        }
      }
    } catch (error) {
      const errorMessage = getErrorString(error);
      if (errorMessage === "User Already has premium Access") {
        setIsSubscribed(true);
        notifier.info("User already has premium access.");
      } else {
        notifier.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    isOpen && (
      <div className="popup-overlay">
        <div className="popup-box">
          <div className="popup-header">
            <h2>PREMIUM SUBSCRIPTION</h2>
            <button className="close-btn" onClick={onClose}>X</button>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <>
              <ul className="popup-content">
                <li><span role="img" aria-label="robot">🤖</span> Unlimited access to Siki Bot AI</li>
                <li><span role="img" aria-label="music-note">🎵</span> 750 monthly streams</li>
                <li><span role="img" aria-label="nft">🎨</span> 30% off on NFT creations</li>
                <li><span role="img" aria-label="badge">✔️</span> Premium badge in-app</li>
              </ul>
              <div className="popup-footer">
                <button
                  className="subscribe-btn"
                  onClick={!isSubscribed ? handleSubscribe : null}
                  disabled={isSubscribed}
                >
                  {isSubscribed ? "Already Subscribed" : "Subscribe"}
                </button>
                <p className="billing-info">* $12.99 billed monthly</p>
              </div>
            </>
          )}
        </div>
      </div>
    )
  );
};

export default SubscriptionPopup;
